import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Undo2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MovedToProviders = ({ refreshKey, onRestored }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);

  const load = () => axios.get(`${API}/admin/supplier-types/moved`).then((r) => setRows(r.data.moved || [])).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  if (!rows.length) return null;

  const restore = async (ids, label) => {
    setBusy(label);
    try {
      const r = await axios.post(`${API}/admin/supplier-types/restore`, { ids });
      toast.success(`${r.data.restored} restored to the directory as suppliers`);
      await load();
      onRestored && onRestored();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not restore'); }
    finally { setBusy(null); }
  };

  return (
    <div className="border border-gray-200 bg-white rounded-lg px-4 py-3 mb-4 space-y-3" data-testid="moved-to-providers">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-gray-700">{rows.length} moved to care providers</span>
        <button onClick={() => setOpen((o) => !o)} className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 shrink-0" data-testid="moved-to-providers-toggle">{open ? 'Hide' : 'View'}</button>
      </div>
      {open && (
        <>
          <div className="max-h-[40vh] overflow-y-auto rounded-lg border border-gray-100 divide-y divide-gray-100">
            {rows.map((r) => (
              <div key={r.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`moved-row-${r.id}`}>
                <span className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center sm:gap-3">
                  <span className="font-medium text-gray-900 truncate sm:flex-1">{r.name}</span>
                  <span className="text-[11px] text-gray-400 sm:shrink-0">Moved {new Date(r.reclassified_at).toLocaleDateString('en-GB')}{r.reclassified_by ? ` by ${r.reclassified_by.split('@')[0]}` : ''}</span>
                </span>
                <button onClick={() => restore([r.id], r.id)} disabled={!!busy}
                  className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1.5 rounded-lg text-[#00857D] hover:bg-[#E6F6F5] shrink-0 disabled:opacity-50" data-testid={`restore-btn-${r.id}`}>
                  {busy === r.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Undo2 className="w-3.5 h-3.5" />}Restore
                </button>
              </div>
            ))}
          </div>
          {rows.length > 1 && (
            <div className="flex justify-end">
              <button onClick={() => window.confirm(`Restore all ${rows.length} to the directory as suppliers?`) && restore(rows.map((r) => r.id), 'all')} disabled={!!busy}
                className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50" data-testid="restore-all-btn">
                {busy === 'all' ? 'Restoring...' : 'Restore all'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
